import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { AccountSentimentReportAverageTotalsEntity } from '../../entities/sentiment/account-sentiment-report-average-totals.entity';

export interface AccountSentimentReportAverageSummaryAggregateRootProps {
  thisPeriod: AccountSentimentReportAverageTotalsEntity;
  lastPeriod: AccountSentimentReportAverageTotalsEntity;
}

export class AccountSentimentReportAverageSummaryAggregateRoot extends Entity<AccountSentimentReportAverageSummaryAggregateRootProps> {
  protected _id: string;
  static create(
    props: AccountSentimentReportAverageSummaryAggregateRootProps,
    entityId?: string
  ): AccountSentimentReportAverageSummaryAggregateRoot {
    const id = entityId || v4();
    const entity = new AccountSentimentReportAverageSummaryAggregateRoot({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  get averageScoreDeviation(): number {
    return this.averageScore - this.lastPeriodAverageScore;
  }

  // this period
  get count(): number {
    return this.props.thisPeriod.count;
  }
  get totalScore(): number {
    return this.props.thisPeriod.totalScore;
  }
  get averageScore(): number {
    return this.count > 0
      ? Number(this.totalScore / this.count)
      : this.totalScore;
  }

  // last period
  get lastPeriodCount(): number {
    return this.props.lastPeriod.count;
  }
  get lastPeriodTotalScore(): number {
    return this.props.lastPeriod.totalScore;
  }
  get lastPeriodAverageScore(): number {
    return this.lastPeriodCount > 0
      ? Number(this.lastPeriodTotalScore / this.lastPeriodCount)
      : this.lastPeriodTotalScore;
  }
}
